import _defineProperty from "/usr/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var __jsx = React.createElement;
import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from '@i18n';
import { thumbUrl } from '@/utils/imagesHelpers';
import ProgressiveImage from '@componentsShared/ProgressiveImage';
import { Icon } from "@syarahtech/ui";
import useIsMobile from "@hooks/useIsMobile";
import useIsIOS from "@hooks/useIsIOS";
import { useLang } from "@/common/Contexts/LanguageContext";
import { checkFeatureFlag } from "@/common/config/websiteConfig";
import { SHOW_DEBUG_INFO } from "@globalConfig";
import ColorIndicators from "@/components/SearchComponent/ModernCard/ColorIndicators";
import stl from "@/components/SearchComponent/UnbxdComponents/UnbxdCard/CardHeader/CardHeader.module.css";
import AddToFavoriteButton from "@/common/HOCs/AddToFavorite/AddToFavoriteButton";
//@ts-ignore

// Feature flag for iOS swipe functionality
var IOS_SWIPE_ENABLED = checkFeatureFlag('FF_ENABLE_MULTI_LIST_GALLERY_IOS_SWIPE');
var ModernCardHeader = function ModernCardHeader(_ref) {
  var _post$images_urls2, _post$images_urls4, _post$images_urls5, _post$images_urls7, _post$images_urls8, _post$images_urls9;
  var post = _ref.post,
    _ref$isEager = _ref.isEager,
    isEager = _ref$isEager === void 0 ? false : _ref$isEager,
    to_link = _ref.to_link,
    _ref$rank = _ref.rank,
    rank = _ref$rank === void 0 ? 0 : _ref$rank,
    _ref$isCustomDesign = _ref.isCustomDesign,
    isCustomDesign = _ref$isCustomDesign === void 0 ? false : _ref$isCustomDesign,
    _ref$hideFavIcon = _ref.hideFavIcon,
    hideFavIcon = _ref$hideFavIcon === void 0 ? false : _ref$hideFavIcon,
    _ref$showMarketingLab = _ref.showMarketingLabel,
    showMarketingLabel = _ref$showMarketingLab === void 0 ? false : _ref$showMarketingLab,
    _ref$hideDiscountLabe = _ref.hideDiscountLabel,
    hideDiscountLabel = _ref$hideDiscountLabe === void 0 ? false : _ref$hideDiscountLabe,
    _ref$HasImageSlider = _ref.HasImageSlider,
    HasImageSlider = _ref$HasImageSlider === void 0 ? false : _ref$HasImageSlider,
    _ref$slideOnlyOnArr = _ref.slideOnlyOnArr,
    slideOnlyOnArr = _ref$slideOnlyOnArr === void 0 ? false : _ref$slideOnlyOnArr,
    _ref$isAnchor = _ref.isAnchor,
    isAnchor = _ref$isAnchor === void 0 ? false : _ref$isAnchor,
    _ref$showDiscountLabe = _ref.showDiscountLabel,
    showDiscountLabel = _ref$showDiscountLabe === void 0 ? true : _ref$showDiscountLabe;
  var _useTranslation = useTranslation(['web_search']),
    t = _useTranslation.t;
  var isMobile = useIsMobile();
  var isIos = useIsIOS();
  var lang = useLang();
  var _useState = useState(0),
    selectedIndex = _useState[0],
    setSelectedIndex = _useState[1];
  var _useState2 = useState(true),
    showAllImages = _useState2[0],
    setShowAllImages = _useState2[1];
  var _useState3 = useState(false),
    openGalleryInPost = _useState3[0],
    setOpenGalleryInPost = _useState3[1];
  var _useState4 = useState(null),
    scrollDirection = _useState4[0],
    setScrollDirection = _useState4[1];
  var startX = useRef(0);
  var startY = useRef(0);
  var currentX = useRef(0);
  var currentY = useRef(0);
  var isSwiping = useRef(false);
  var isSwipeEnabled = IOS_SWIPE_ENABLED && isIos || !isIos;

  // Reset showAllImages when selectedIndex changes
  useEffect(function () {
    if (selectedIndex !== 0) {
      setShowAllImages(true);
    }
  }, [selectedIndex]);

  // Set openGalleryInPost when selectedIndex reaches the last image
  useEffect(function () {
    var _post$images_urls;
    if (!HasImageSlider) return;
    if (selectedIndex === (post === null || post === void 0 ? void 0 : (_post$images_urls = post.images_urls) === null || _post$images_urls === void 0 ? void 0 : _post$images_urls.length) - 1) {
      setOpenGalleryInPost(true);
    } else {
      setOpenGalleryInPost(false);
    }
  }, [selectedIndex, post === null || post === void 0 ? void 0 : (_post$images_urls2 = post.images_urls) === null || _post$images_urls2 === void 0 ? void 0 : _post$images_urls2.length, HasImageSlider]);

  // Touch event handlers for image slider
  var handleTouchStart = function handleTouchStart(event) {
    if (!isSwipeEnabled) return;
    startX.current = event.touches[0].clientX;
    startY.current = event.touches[0].clientY;
    isSwiping.current = true;
  };
  var handleTouchMove = function handleTouchMove(event) {
    if (!isSwipeEnabled || !isSwiping.current) return;
    currentX.current = event.touches[0].clientX;
    currentY.current = event.touches[0].clientY;
    var deltaX = Math.abs(startX.current - currentX.current);
    var deltaY = Math.abs(startY.current - currentY.current);
    if (deltaX > deltaY * 2) {
      setScrollDirection('horizontal');
    } else {
      setScrollDirection('vertical');
    }
  };
  var handleTouchEnd = function handleTouchEnd() {
    if (!isSwipeEnabled || !isSwiping.current) return;
    var deltaX = startX.current - currentX.current;
    var threshold = 50;
    if (lang === "ar" && deltaX < -threshold || lang === "en" && deltaX > threshold) {
      doSlide("next");
    } else if (lang === "ar" && deltaX > threshold || lang === "en" && deltaX < -threshold) {
      doSlide("prev");
    }
    isSwiping.current = false;
    setScrollDirection(null);
  };

  // Handle sliding through images
  var doSlide = function doSlide(nextOrPrev) {
    var _post$images_urls3;
    if (scrollDirection !== 'vertical' && post !== null && post !== void 0 && (_post$images_urls3 = post.images_urls) !== null && _post$images_urls3 !== void 0 && _post$images_urls3.length) {
      var imagesLength = post.images_urls.length - 1;
      if (nextOrPrev === "prev") {
        setSelectedIndex(selectedIndex === 0 ? imagesLength : selectedIndex - 1);
      } else if (nextOrPrev === "next") {
        setSelectedIndex(selectedIndex === imagesLength ? 0 : selectedIndex + 1);
      }
    }
  };

  // Determine the tag to use (Link or a) based on isAnchor prop
  var Tag = isAnchor ? "a" : Link;
  var LinkType = isAnchor ? "href" : "to";
  return /*#__PURE__*/React.createElement("div", {
    className: "relative"
  }, /*#__PURE__*/React.createElement("div", {
    className: "absolute top-0 left-0 z-10 flex p-3 items-center justify-between w-full"
  }, !hideFavIcon && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AddToFavoriteButton, {
    postId: +(post.uniqueId || post.id),
    className: stl.FavoriteButton,
    g4_data: post.g4_data_layer
  })), post.campaign_id && !post.limited_quantity && !isCustomDesign && showMarketingLabel && /*#__PURE__*/React.createElement("p", {
    className: "z-10 text-white px-2 rounded-full font-bold line-clamp-1 max-w-[180px] leading-[28px] text-[10px] ml-auto rtl:ml-0 rtl:mr-auto",
    style: {
      backgroundColor: post.campaign_bg_color_hex || "#903CD4"
    }
  }, post.campaign_txt)), post.is_booked && /*#__PURE__*/React.createElement("div", {
    className: "absolute inset-0 bg-gray-600 bg-opacity-60 flex items-center justify-center z-30 rounded-t-lg"
  }, /*#__PURE__*/React.createElement("div", {
    className: "absolute right-0 bottom-0 bg-gray-700 rounded-tl-lg w-[74px] h-6 flex justify-center items-center text-white text-xs font-bold"
  }, t("محجوزة", {
    ns: "web_search"
  }))), ((post === null || post === void 0 ? void 0 : (_post$images_urls4 = post.images_urls) === null || _post$images_urls4 === void 0 ? void 0 : _post$images_urls4.length) === 1 || !HasImageSlider) && post !== null && post !== void 0 && post.image_url ? /*#__PURE__*/React.createElement(Tag, _defineProperty({}, LinkType, to_link), /*#__PURE__*/React.createElement("div", {
    className: "relative h-56 w-full"
  }, /*#__PURE__*/React.createElement(ProgressiveImage, {
    alt: post !== null && post !== void 0 && post.title ? post === null || post === void 0 ? void 0 : post.title : "car",
    src: thumbUrl(post.image_url, "online-v1", "0x426"),
    loading: isEager ? "eager" : "lazy",
    fetchpriority: isEager ? "high" : "low",
    progressiveSmallImage: thumbUrl(post === null || post === void 0 ? void 0 : post.image_url, "online-v1", isMobile ? "0x99" : "0x154"),
    className: "w-full h-full object-cover",
    width: 400,
    height: 224
  }))) :
  /*#__PURE__*/
  /* Image Slider */
  React.createElement("div", {
    className: "relative h-56 w-full overflow-hidden",
    onTouchStart: !slideOnlyOnArr ? handleTouchStart : undefined,
    onTouchMove: !slideOnlyOnArr ? handleTouchMove : undefined,
    onTouchEnd: !slideOnlyOnArr ? handleTouchEnd : undefined,
    style: {
      touchAction: scrollDirection === 'horizontal' ? 'pan-x' : 'pan-y'
    }
  }, SHOW_DEBUG_INFO && /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'relative',
      fontSize: '50px',
      width: '70px',
      color: 'red',
      zIndex: 1,
      textAlign: 'left'
    }
  }, rank), SHOW_DEBUG_INFO && post.uniqueId && /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'relative',
      fontSize: '20px',
      width: '70px',
      color: 'green',
      zIndex: 1,
      textAlign: 'left'
    }
  }, "id: ", post.uniqueId.toString().substring(3)), /*#__PURE__*/React.createElement("span", {
    className: "flex items-center p-4 justify-center absolute top-1/2 right-0 transform -translate-y-1/2 rounded-full z-20  cursor-pointer ".concat(selectedIndex === 0 ? 'opacity-0' : ''),
    onClick: function onClick() {
      return selectedIndex !== 0 && doSlide("prev");
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "bg-[rgba(72,72,72,0.6)] rounded-full w-6 h-6"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "materz-40 material-symbols--chevron-right-rounded",
    width: 6,
    height: 6,
    className: "fill-current text-white"
  }))), /*#__PURE__*/React.createElement("span", {
    className: "flex items-center p-4 justify-center absolute top-1/2 left-0 transform -translate-y-1/2  z-20  cursor-pointer ".concat(selectedIndex === (((_post$images_urls5 = post.images_urls) === null || _post$images_urls5 === void 0 ? void 0 : _post$images_urls5.length) || 0) - 1 ? 'opacity-0' : ''),
    onClick: function onClick() {
      var _post$images_urls6;
      return selectedIndex !== (((_post$images_urls6 = post.images_urls) === null || _post$images_urls6 === void 0 ? void 0 : _post$images_urls6.length) || 0) - 1 && doSlide("next");
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "bg-[rgba(72,72,72,0.6)] rounded-full w-6 h-6"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "material-symbols--chevron-left-rounded",
    width: 6,
    height: 6,
    className: "fill-current text-white"
  }))), /*#__PURE__*/React.createElement(Tag, _defineProperty({}, LinkType, to_link + (((_post$images_urls7 = post.images_urls) === null || _post$images_urls7 === void 0 ? void 0 : _post$images_urls7.length) === selectedIndex + 1 ? "".concat(to_link.includes("#") ? "&" : "#", "bigGallView=").concat(openGalleryInPost ? 1 : 0) : "")), (_post$images_urls8 = post.images_urls) === null || _post$images_urls8 === void 0 ? void 0 : _post$images_urls8.map(function (image, idx) {
    return (idx === 0 || showAllImages) && /*#__PURE__*/React.createElement("div", {
      key: idx,
      className: "absolute inset-0 transition-all duration-300 ".concat(idx === selectedIndex ? 'opacity-100' : idx > selectedIndex ? 'opacity-10 translate-x-full' : 'opacity-10 -translate-x-full')
    }, /*#__PURE__*/React.createElement(ProgressiveImage, {
      src: thumbUrl(image, "online-v1", "0x426"),
      alt: post !== null && post !== void 0 && post.title ? post === null || post === void 0 ? void 0 : post.title : "car",
      loading: idx === 0 && isEager ? "eager" : "lazy",
      fetchpriority: isEager ? "high" : "low",
      progressiveSmallImage: thumbUrl(post === null || post === void 0 ? void 0 : post.image_url, "online-v1", isMobile ? "0x99" : "0x154"),
      className: "w-full h-full object-cover",
      width: 400,
      height: 224
    }));
  })), HasImageSlider && ((_post$images_urls9 = post.images_urls) === null || _post$images_urls9 === void 0 ? void 0 : _post$images_urls9.length) === selectedIndex + 1 && /*#__PURE__*/React.createElement("div", {
    className: "absolute inset-0 bg-[rgba(72,72,72,0.4)] flex items-center justify-center z-20 pointer-events-none"
  }, /*#__PURE__*/React.createElement("span", {
    className: "border border-white text-white p-3 rounded-md text-sm font-bold border-solid"
  }, t("شاهد جميع الصور", {
    ns: "web_search"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "absolute bottom-0 left-0 z-10 flex p-3 items-center justify-between w-full"
  }, showDiscountLabel ? /*#__PURE__*/React.createElement(React.Fragment, null, post.discount && !isCustomDesign && !hideDiscountLabel ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "z-10 bg-[#FF6029] text-white px-2 py-1 rounded-l rounded-tl -ms-4 relative"
  }, /*#__PURE__*/React.createElement("img", {
    src: "/assets/images/discount-ar.svg",
    alt: "discount",
    className: "absolute -top-2 left-1/2 transform -translate-x-1/2 w-8 h-4"
  }), /*#__PURE__*/React.createElement("span", {
    className: "text-xs font-bold"
  }, post.discount, " ", t("ريال", {
    ns: "web_search"
  })))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "w-2 h-2"
  }))) : null, post.color_variants && post.color_variants.length > 1 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ColorIndicators, {
    colors: post.color_variants
  }))));
};
export default ModernCardHeader;